import { render, staticRenderFns } from "./AddLicenses.vue?vue&type=template&id=d730a10e&scoped=true&"
import script from "./AddLicenses.vue?vue&type=script&lang=ts&"
export * from "./AddLicenses.vue?vue&type=script&lang=ts&"
import style0 from "./AddLicenses.vue?vue&type=style&index=0&id=d730a10e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d730a10e",
  null
  
)

export default component.exports